import { useState, useEffect } from 'react';

export interface WebSchedulerScriptProps {
    scriptUrl: string;
    publicCode: string;
}

export function useLoadWebSchedulerScript(props: WebSchedulerScriptProps) {
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = useState(false);

    useEffect(() => {
        const scriptTag = document.createElement('script');
        scriptTag.textContent = `
(function(q,w,e,r,t,y,u){q[t]=q[t]||function(){(q[t].q = q[t].q || []).push(arguments)};
  q[t].l=1*new Date();y=w.createElement(e);u=w.getElementsByTagName(e)[0];y.async=true;
  y.src=r;u.parentNode.insertBefore(y,u);q[t]('init', '${props.publicCode}');
})(window, document, 'script', '${props.scriptUrl}', 'STWidgetManager');`;

        document.body.appendChild(scriptTag);

        setScriptLoadedSuccessfully(true);

        return () => {
            document.body.removeChild(scriptTag);
        };
    }, [props.publicCode, props.scriptUrl]);

    return scriptLoadedSuccessfully;
}
